import { ReactNode, lazy, Suspense } from 'react';
import { User } from '@supabase/supabase-js';

// Lazy load presence provider only when needed
const PresenceProvider = lazy(() => 
  import('./PresenceProvider').then(module => ({ default: module.PresenceProvider }))
);

interface ConditionalPresenceProviderProps {
  children: ReactNode;
  user: User | null;
  isAdminRoute?: boolean;
}

// Only load presence provider for admin routes or when explicitly needed
export const ConditionalPresenceProvider = ({ 
  children, 
  user, 
  isAdminRoute = false 
}: ConditionalPresenceProviderProps) => {
  // Skip presence provider for non-admin users to save resources
  if (!isAdminRoute) {
    return <>{children}</>;
  }

  return (
    <Suspense fallback={<>{children}</>}>
      <PresenceProvider user={user}>
        {children}
      </PresenceProvider>
    </Suspense>
  );
};